export const newsletterDeliverabilityDe = {
  tab: 'Zustellbarkeit',
  title: 'Versanddomains und Zustellbarkeit',
  description:
    'Marketing-Versand wird erst nach aktueller SPF-, DKIM-, DMARC-, Return-Path-, Absender- und Domainprüfung freigegeben. Transaktions-E-Mails verwenden weiterhin ihren getrennten Versandstrom.',
  measurementNotice:
    'Zustellung ist eine Provider-Rückmeldung und keine garantierte Postfachzustellung. Raten beziehen sich auf die letzten 30 Tage.',
  providersTitle: 'Marketing-Versandprovider',
  providersDescription:
    'Zugangsdaten werden verschlüsselt gespeichert. Angezeigte Geheimnisse werden nie erneut geladen.',
  domainTitle: 'Marketing-Versanddomain',
  domainDescription:
    'Verwenden Sie eine eigene Subdomain. Veröffentlichen Sie die angezeigten DNS-Einträge und starten Sie danach die Prüfung.',
  noDomains: 'Noch keine Marketing-Versanddomain eingerichtet.',
  noProviders: 'Noch kein eigener Marketing-Versandprovider eingerichtet.',
  metrics: {
    accepted: 'Vom Provider angenommen',
    delivered: 'Vom Provider als zugestellt gemeldet',
    softBounces: 'Temporäre Fehler',
    hardBounces: 'Dauerhafte Fehler',
    complaints: 'Spam-Beschwerden',
    deliveredRate: 'Gemeldete Zustellrate',
    bounceRate: 'Bounce-Rate',
    complaintRate: 'Beschwerderate',
  },
  alertTitle: 'Zustellbarkeitsalarm',
  alerts: {
    BOUNCE_RATE_HIGH: 'Die Bounce-Rate liegt über dem konfigurierten Schwellenwert.',
    COMPLAINT_RATE_HIGH: 'Die Beschwerderate liegt über dem konfigurierten Schwellenwert.',
  },
  fields: {
    providerName: 'Providername',
    providerType: 'Transport',
    fromAddress: 'Marketing-Absenderadresse',
    host: 'SMTP-Host',
    port: 'SMTP-Port',
    secure: 'SMTP über TLS verbinden',
    username: 'SMTP-Benutzername (optional)',
    password: 'SMTP-Passwort (optional)',
    dkimDomain: 'Lokale DKIM-Domain (optional)',
    dkimSelector: 'Lokaler DKIM-Selektor (optional)',
    dkimPrivateKey: 'Lokaler DKIM-Privatschlüssel (optional)',
    makeDefault: 'Als Standard-Marketingprovider verwenden',
    provider: 'Marketingprovider',
    domain: 'Eigene Marketing-Subdomain',
    sender: 'Absenderadresse',
    returnPath: 'Return-Path-Adresse',
    selector: 'DKIM-Selektor',
    evidence: 'Dokumentierte Konfiguration und Verantwortlichkeit',
    coverage:
      'Ich habe bestätigt, dass DKIM alle erforderlichen Marketing- und Abmelde-Header signiert.',
    softBounceThreshold: 'Soft-Bounce-Grenze',
    validityHours: 'Gültigkeit einer Domainprüfung in Stunden',
    bounceAlert: 'Bounce-Alarm in Prozent',
    complaintAlert: 'Beschwerde-Alarm in Prozent',
    riskAcknowledgement: 'Ich bestätige die fachliche Prüfung dieser betrieblichen Schwellenwerte.',
  },
  types: { SHARED_SMTP: 'Bestehender gemeinsamer SMTP-Transport', SMTP: 'Eigener SMTP-Transport' },
  actions: {
    createProvider: 'Provider speichern',
    createDomain: 'Versanddomain anlegen',
    check: 'DNS jetzt prüfen',
    rotateToken: 'Verifikationstoken erneuern',
    rotateWebhook: 'Webhook-Geheimnis erneuern',
    saveSettings: 'Schwellenwerte speichern',
  },
  status: { PENDING: 'Ausstehend', VERIFIED: 'Verifiziert', FAILED: 'Fehlgeschlagen' },
  check: { PENDING: 'Ausstehend', PASS: 'Bestanden', FAIL: 'Fehlgeschlagen' },
  checks: {
    ownership: 'Domainbesitz',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return-Path',
    sender: 'Absender und getrennter Versandstrom',
  },
  recordsTitle: 'Erforderliche DNS-Einträge',
  ownershipRecord: 'TXT zur Domainverifikation',
  spfRecord: 'TXT für SPF am Return-Path',
  dkimRecord: 'TXT mit dem öffentlichen DKIM-Schlüssel',
  dmarcRecord: 'TXT für DMARC',
  requiredHeaders: 'Erforderliche DKIM-Header',
  lastChecked: 'Zuletzt geprüft',
  neverChecked: 'Noch nicht geprüft',
  oneTimeTitle: 'Einmalig angezeigte Konfigurationsdaten',
  tokenWarning:
    'Kopieren Sie diesen Wert jetzt in den DNS-Eintrag. Der Klartext wird nicht gespeichert und kann später nur ersetzt werden.',
  webhookTitle: 'Signierter Provider-Webhook',
  webhookDescription:
    'Der Provider sendet HTTPS-POST-Ereignisse mit Zeitstempel und HMAC-SHA-256-Signatur. Ereignis-IDs müssen idempotent und eindeutig sein.',
  webhookWarning:
    'Kopieren Sie URL und Geheimnis jetzt in die Providerkonfiguration. Das Geheimnis wird anschließend nicht erneut angezeigt.',
  webhookUrl: 'Webhook-URL',
  webhookSecret: 'Webhook-Geheimnis',
  signatureHeader: 'Signatur-Header',
  timestampHeader: 'Zeitstempel-Header',
  settingsTitle: 'Bounce- und Alarmgrenzen',
  messages: {
    providerCreated: 'Der Marketingprovider wurde verschlüsselt gespeichert.',
    domainCreated: 'Die Versanddomain wurde angelegt. Veröffentlichen Sie nun die DNS-Einträge.',
    domainChecked: 'Die DNS-Prüfung wurde unveränderlich protokolliert.',
    tokenRotated: 'Das alte Verifikationstoken wurde widerrufen.',
    webhookRotated: 'Das Webhook-Geheimnis wurde erneuert.',
    settingsSaved: 'Die Zustellbarkeitsschwellen wurden gespeichert.',
    failed: 'Die Zustellbarkeitskonfiguration konnte nicht gespeichert oder geprüft werden.',
  },
} as const;

export const newsletterDeliverabilityEn = {
  ...newsletterDeliverabilityDe,
  tab: 'Deliverability',
  title: 'Sending domains and deliverability',
  description:
    'Marketing delivery is enabled only after current SPF, DKIM, DMARC, return-path, sender and domain checks. Transactional email continues to use its separate delivery stream.',
  measurementNotice:
    'Delivery is a provider report, not guaranteed inbox delivery. Rates cover the last 30 days.',
  providersTitle: 'Marketing delivery providers',
  providersDescription:
    'Credentials are stored encrypted. Displayed secrets are never loaded again.',
  domainTitle: 'Marketing sending domain',
  domainDescription:
    'Use a dedicated subdomain. Publish the displayed DNS records and then run the check.',
  noDomains: 'No marketing sending domain has been configured.',
  noProviders: 'No dedicated marketing delivery provider has been configured.',
  metrics: {
    accepted: 'Accepted by provider',
    delivered: 'Reported delivered by provider',
    softBounces: 'Temporary failures',
    hardBounces: 'Permanent failures',
    complaints: 'Spam complaints',
    deliveredRate: 'Reported delivery rate',
    bounceRate: 'Bounce rate',
    complaintRate: 'Complaint rate',
  },
  alertTitle: 'Deliverability alert',
  alerts: {
    BOUNCE_RATE_HIGH: 'The bounce rate exceeds the configured threshold.',
    COMPLAINT_RATE_HIGH: 'The complaint rate exceeds the configured threshold.',
  },
  fields: {
    providerName: 'Provider name',
    providerType: 'Transport',
    fromAddress: 'Marketing sender address',
    host: 'SMTP host',
    port: 'SMTP port',
    secure: 'Connect to SMTP with TLS',
    username: 'SMTP username (optional)',
    password: 'SMTP password (optional)',
    dkimDomain: 'Local DKIM domain (optional)',
    dkimSelector: 'Local DKIM selector (optional)',
    dkimPrivateKey: 'Local DKIM private key (optional)',
    makeDefault: 'Use as default marketing provider',
    provider: 'Marketing provider',
    domain: 'Dedicated marketing subdomain',
    sender: 'Sender address',
    returnPath: 'Return-path address',
    selector: 'DKIM selector',
    evidence: 'Documented configuration and responsibility',
    coverage: 'I confirmed that DKIM signs every required marketing and unsubscribe header.',
    softBounceThreshold: 'Soft-bounce threshold',
    validityHours: 'Domain-check validity in hours',
    bounceAlert: 'Bounce alert percentage',
    complaintAlert: 'Complaint alert percentage',
    riskAcknowledgement: 'I confirm the operational review of these thresholds.',
  },
  types: { SHARED_SMTP: 'Existing shared SMTP transport', SMTP: 'Dedicated SMTP transport' },
  actions: {
    createProvider: 'Save provider',
    createDomain: 'Add sending domain',
    check: 'Check DNS now',
    rotateToken: 'Rotate verification token',
    rotateWebhook: 'Rotate webhook secret',
    saveSettings: 'Save thresholds',
  },
  status: { PENDING: 'Pending', VERIFIED: 'Verified', FAILED: 'Failed' },
  check: { PENDING: 'Pending', PASS: 'Passed', FAIL: 'Failed' },
  checks: {
    ownership: 'Domain ownership',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return path',
    sender: 'Sender and separate stream',
  },
  recordsTitle: 'Required DNS records',
  ownershipRecord: 'Domain-verification TXT',
  spfRecord: 'SPF TXT at return path',
  dkimRecord: 'TXT with the public DKIM key',
  dmarcRecord: 'DMARC TXT',
  requiredHeaders: 'Required DKIM headers',
  lastChecked: 'Last checked',
  neverChecked: 'Not checked yet',
  oneTimeTitle: 'Configuration data shown once',
  tokenWarning:
    'Copy this value into DNS now. Plaintext is not stored and can only be replaced later.',
  webhookTitle: 'Signed provider webhook',
  webhookDescription:
    'The provider sends HTTPS POST events with a timestamp and HMAC-SHA-256 signature. Event IDs must be unique and idempotent.',
  webhookWarning:
    'Copy the URL and secret into the provider configuration now. The secret will not be displayed again.',
  webhookUrl: 'Webhook URL',
  webhookSecret: 'Webhook secret',
  signatureHeader: 'Signature header',
  timestampHeader: 'Timestamp header',
  settingsTitle: 'Bounce and alert thresholds',
  messages: {
    providerCreated: 'The marketing provider was stored encrypted.',
    domainCreated: 'The sending domain was added. Publish the DNS records now.',
    domainChecked: 'The DNS check was logged immutably.',
    tokenRotated: 'The old verification token was revoked.',
    webhookRotated: 'The webhook secret was rotated.',
    settingsSaved: 'The deliverability thresholds were saved.',
    failed: 'The deliverability configuration could not be saved or checked.',
  },
} as const;

export const newsletterDeliverabilityTr = {
  ...newsletterDeliverabilityEn,
  tab: 'Teslim edilebilirlik',
  title: 'Gönderim alan adları ve teslim edilebilirlik',
  description:
    'Pazarlama gönderimi yalnızca güncel SPF, DKIM, DMARC, Return-Path, gönderen ve alan adı kontrollerinden sonra açılır. İşlem e-postaları ayrı akışını kullanır.',
  measurementNotice:
    'Teslimat, sağlayıcı bildirimi olup gelen kutusuna ulaşma garantisi değildir. Oranlar son 30 günü kapsar.',
  providersTitle: 'Pazarlama gönderim sağlayıcıları',
  providersDescription: 'Kimlik bilgileri şifreli saklanır. Gösterilen sırlar yeniden yüklenmez.',
  domainTitle: 'Pazarlama gönderim alan adı',
  domainDescription:
    'Özel bir alt alan adı kullanın, DNS kayıtlarını yayımlayın ve kontrolü başlatın.',
  noDomains: 'Henüz pazarlama gönderim alan adı yok.',
  noProviders: 'Henüz pazarlama gönderim sağlayıcısı yok.',
  metrics: {
    accepted: 'Sağlayıcı kabul etti',
    delivered: 'Sağlayıcı teslim edildi bildirdi',
    softBounces: 'Geçici hatalar',
    hardBounces: 'Kalıcı hatalar',
    complaints: 'Spam şikâyetleri',
    deliveredRate: 'Bildirilen teslim oranı',
    bounceRate: 'Geri dönme oranı',
    complaintRate: 'Şikâyet oranı',
  },
  alertTitle: 'Teslim edilebilirlik uyarısı',
  alerts: {
    BOUNCE_RATE_HIGH: 'Geri dönme oranı yapılandırılan sınırı aştı.',
    COMPLAINT_RATE_HIGH: 'Şikâyet oranı yapılandırılan sınırı aştı.',
  },
  fields: {
    ...newsletterDeliverabilityEn.fields,
    providerName: 'Sağlayıcı adı',
    providerType: 'Aktarım',
    fromAddress: 'Pazarlama gönderen adresi',
    host: 'SMTP sunucusu',
    port: 'SMTP bağlantı noktası',
    secure: 'SMTP’ye TLS ile bağlan',
    username: 'SMTP kullanıcı adı (isteğe bağlı)',
    password: 'SMTP parolası (isteğe bağlı)',
    dkimDomain: 'Yerel DKIM alan adı (isteğe bağlı)',
    dkimSelector: 'Yerel DKIM seçicisi (isteğe bağlı)',
    dkimPrivateKey: 'Yerel DKIM özel anahtarı (isteğe bağlı)',
    makeDefault: 'Varsayılan pazarlama sağlayıcısı yap',
    provider: 'Pazarlama sağlayıcısı',
    domain: 'Özel pazarlama alt alan adı',
    sender: 'Gönderen adresi',
    returnPath: 'Return-Path adresi',
    selector: 'DKIM seçicisi',
    evidence: 'Belgelenmiş yapılandırma ve sorumluluk',
    coverage:
      'DKIM’in gerekli pazarlama ve abonelikten çıkma başlıklarını imzaladığını doğruladım.',
    softBounceThreshold: 'Geçici geri dönme sınırı',
    validityHours: 'Alan adı kontrol geçerliliği (saat)',
    bounceAlert: 'Geri dönme uyarı yüzdesi',
    complaintAlert: 'Şikâyet uyarı yüzdesi',
    riskAcknowledgement: 'Bu eşiklerin operasyonel incelemesini onaylıyorum.',
  },
  types: { SHARED_SMTP: 'Mevcut ortak SMTP aktarımı', SMTP: 'Özel SMTP aktarımı' },
  actions: {
    createProvider: 'Sağlayıcıyı kaydet',
    createDomain: 'Gönderim alan adı ekle',
    check: 'DNS’i şimdi kontrol et',
    rotateToken: 'Doğrulama belirtecini yenile',
    rotateWebhook: 'Webhook sırrını yenile',
    saveSettings: 'Eşikleri kaydet',
  },
  status: { PENDING: 'Beklemede', VERIFIED: 'Doğrulandı', FAILED: 'Başarısız' },
  check: { PENDING: 'Beklemede', PASS: 'Başarılı', FAIL: 'Başarısız' },
  checks: {
    ownership: 'Alan adı sahipliği',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return-Path',
    sender: 'Gönderen ve ayrı akış',
  },
  recordsTitle: 'Gerekli DNS kayıtları',
  ownershipRecord: 'Alan adı doğrulama TXT kaydı',
  spfRecord: 'Return-Path için SPF TXT',
  dkimRecord: 'Açık DKIM anahtarı TXT kaydı',
  dmarcRecord: 'DMARC TXT kaydı',
  requiredHeaders: 'Gerekli DKIM başlıkları',
  lastChecked: 'Son kontrol',
  neverChecked: 'Henüz kontrol edilmedi',
  oneTimeTitle: 'Bir kez gösterilen yapılandırma verileri',
  tokenWarning:
    'Bu değeri şimdi DNS’e kopyalayın. Açık metin saklanmaz ve sonra yalnızca yenilenebilir.',
  webhookTitle: 'İmzalı sağlayıcı webhook’u',
  webhookDescription:
    'Sağlayıcı, zaman damgası ve HMAC-SHA-256 imzasıyla HTTPS POST olayları gönderir. Olay kimlikleri benzersiz olmalıdır.',
  webhookWarning: 'URL ve sırrı şimdi kopyalayın; sır tekrar gösterilmez.',
  webhookUrl: 'Webhook URL’si',
  webhookSecret: 'Webhook sırrı',
  signatureHeader: 'İmza başlığı',
  timestampHeader: 'Zaman damgası başlığı',
  settingsTitle: 'Geri dönme ve uyarı eşikleri',
  messages: {
    providerCreated: 'Pazarlama sağlayıcısı şifreli kaydedildi.',
    domainCreated: 'Gönderim alan adı eklendi; DNS kayıtlarını yayımlayın.',
    domainChecked: 'DNS kontrolü değiştirilemez biçimde kaydedildi.',
    tokenRotated: 'Eski doğrulama belirteci iptal edildi.',
    webhookRotated: 'Webhook sırrı yenilendi.',
    settingsSaved: 'Teslim edilebilirlik eşikleri kaydedildi.',
    failed: 'Teslim edilebilirlik yapılandırması kaydedilemedi veya kontrol edilemedi.',
  },
} as const;

export const newsletterDeliverabilityFr = {
  ...newsletterDeliverabilityEn,
  tab: 'Délivrabilité',
  title: 'Domaines d’envoi et délivrabilité',
  description:
    'L’envoi marketing n’est autorisé qu’après des contrôles SPF, DKIM, DMARC, Return-Path, expéditeur et domaine à jour. Les e-mails transactionnels conservent leur flux séparé.',
  measurementNotice:
    'La livraison est un signal du fournisseur, sans garantie de remise en boîte de réception. Les taux couvrent les 30 derniers jours.',
  providersTitle: 'Fournisseurs d’envoi marketing',
  providersDescription:
    'Les identifiants sont chiffrés. Les secrets affichés ne sont jamais rechargés.',
  domainTitle: 'Domaine d’envoi marketing',
  domainDescription:
    'Utilisez un sous-domaine dédié, publiez les enregistrements DNS affichés puis lancez le contrôle.',
  noDomains: 'Aucun domaine d’envoi marketing configuré.',
  noProviders: 'Aucun fournisseur marketing dédié configuré.',
  metrics: {
    accepted: 'Accepté par le fournisseur',
    delivered: 'Signalé livré par le fournisseur',
    softBounces: 'Échecs temporaires',
    hardBounces: 'Échecs permanents',
    complaints: 'Plaintes pour spam',
    deliveredRate: 'Taux de livraison signalé',
    bounceRate: 'Taux de rebond',
    complaintRate: 'Taux de plainte',
  },
  alertTitle: 'Alerte de délivrabilité',
  alerts: {
    BOUNCE_RATE_HIGH: 'Le taux de rebond dépasse le seuil configuré.',
    COMPLAINT_RATE_HIGH: 'Le taux de plainte dépasse le seuil configuré.',
  },
  fields: {
    ...newsletterDeliverabilityEn.fields,
    providerName: 'Nom du fournisseur',
    providerType: 'Transport',
    fromAddress: 'Adresse expéditrice marketing',
    host: 'Hôte SMTP',
    port: 'Port SMTP',
    secure: 'Connexion SMTP avec TLS',
    username: 'Nom d’utilisateur SMTP (facultatif)',
    password: 'Mot de passe SMTP (facultatif)',
    dkimDomain: 'Domaine DKIM local (facultatif)',
    dkimSelector: 'Sélecteur DKIM local (facultatif)',
    dkimPrivateKey: 'Clé privée DKIM locale (facultative)',
    makeDefault: 'Utiliser comme fournisseur marketing par défaut',
    provider: 'Fournisseur marketing',
    domain: 'Sous-domaine marketing dédié',
    sender: 'Adresse expéditrice',
    returnPath: 'Adresse Return-Path',
    selector: 'Sélecteur DKIM',
    evidence: 'Configuration et responsabilité documentées',
    coverage: 'Je confirme que DKIM signe tous les en-têtes marketing et de désabonnement requis.',
    softBounceThreshold: 'Seuil de rebonds temporaires',
    validityHours: 'Validité du contrôle en heures',
    bounceAlert: 'Alerte de rebond en pourcentage',
    complaintAlert: 'Alerte de plainte en pourcentage',
    riskAcknowledgement: 'Je confirme l’examen opérationnel de ces seuils.',
  },
  types: { SHARED_SMTP: 'Transport SMTP partagé existant', SMTP: 'Transport SMTP dédié' },
  actions: {
    createProvider: 'Enregistrer le fournisseur',
    createDomain: 'Ajouter le domaine',
    check: 'Contrôler le DNS',
    rotateToken: 'Renouveler le jeton',
    rotateWebhook: 'Renouveler le secret webhook',
    saveSettings: 'Enregistrer les seuils',
  },
  status: { PENDING: 'En attente', VERIFIED: 'Vérifié', FAILED: 'Échec' },
  check: { PENDING: 'En attente', PASS: 'Réussi', FAIL: 'Échec' },
  checks: {
    ownership: 'Propriété du domaine',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return-Path',
    sender: 'Expéditeur et flux séparé',
  },
  recordsTitle: 'Enregistrements DNS requis',
  ownershipRecord: 'TXT de vérification du domaine',
  spfRecord: 'TXT SPF du Return-Path',
  dkimRecord: 'TXT avec la clé DKIM publique',
  dmarcRecord: 'TXT DMARC',
  requiredHeaders: 'En-têtes DKIM requis',
  lastChecked: 'Dernier contrôle',
  neverChecked: 'Pas encore contrôlé',
  oneTimeTitle: 'Données de configuration affichées une fois',
  tokenWarning:
    'Copiez cette valeur dans le DNS maintenant. Le texte clair n’est pas conservé et ne pourra qu’être remplacé.',
  webhookTitle: 'Webhook fournisseur signé',
  webhookDescription:
    'Le fournisseur envoie des événements HTTPS POST horodatés et signés HMAC-SHA-256. Les identifiants doivent être uniques.',
  webhookWarning: 'Copiez maintenant l’URL et le secret ; le secret ne sera plus affiché.',
  webhookUrl: 'URL du webhook',
  webhookSecret: 'Secret du webhook',
  signatureHeader: 'En-tête de signature',
  timestampHeader: 'En-tête d’horodatage',
  settingsTitle: 'Seuils de rebond et d’alerte',
  messages: {
    providerCreated: 'Le fournisseur marketing a été enregistré chiffré.',
    domainCreated: 'Le domaine a été ajouté. Publiez les enregistrements DNS.',
    domainChecked: 'Le contrôle DNS a été journalisé de façon immuable.',
    tokenRotated: 'L’ancien jeton a été révoqué.',
    webhookRotated: 'Le secret webhook a été renouvelé.',
    settingsSaved: 'Les seuils ont été enregistrés.',
    failed: 'Impossible d’enregistrer ou de contrôler la configuration.',
  },
} as const;

export const newsletterDeliverabilityEs = {
  ...newsletterDeliverabilityEn,
  tab: 'Entregabilidad',
  title: 'Dominios de envío y entregabilidad',
  description:
    'El envío de marketing solo se habilita tras comprobar SPF, DKIM, DMARC, Return-Path, remitente y dominio. El correo transaccional mantiene su flujo separado.',
  measurementNotice:
    'La entrega es una notificación del proveedor, no una garantía de llegada a la bandeja. Las tasas cubren los últimos 30 días.',
  providersTitle: 'Proveedores de envío de marketing',
  providersDescription:
    'Las credenciales se guardan cifradas. Los secretos mostrados no vuelven a cargarse.',
  domainTitle: 'Dominio de envío de marketing',
  domainDescription:
    'Use un subdominio dedicado, publique los registros DNS mostrados y ejecute la comprobación.',
  noDomains: 'No hay ningún dominio de envío de marketing configurado.',
  noProviders: 'No hay ningún proveedor de marketing dedicado configurado.',
  metrics: {
    accepted: 'Aceptado por el proveedor',
    delivered: 'Notificado como entregado',
    softBounces: 'Fallos temporales',
    hardBounces: 'Fallos permanentes',
    complaints: 'Quejas de spam',
    deliveredRate: 'Tasa de entrega notificada',
    bounceRate: 'Tasa de rebote',
    complaintRate: 'Tasa de quejas',
  },
  alertTitle: 'Alerta de entregabilidad',
  alerts: {
    BOUNCE_RATE_HIGH: 'La tasa de rebote supera el umbral configurado.',
    COMPLAINT_RATE_HIGH: 'La tasa de quejas supera el umbral configurado.',
  },
  fields: {
    ...newsletterDeliverabilityEn.fields,
    providerName: 'Nombre del proveedor',
    providerType: 'Transporte',
    fromAddress: 'Dirección remitente de marketing',
    host: 'Servidor SMTP',
    port: 'Puerto SMTP',
    secure: 'Conectar a SMTP con TLS',
    username: 'Usuario SMTP (opcional)',
    password: 'Contraseña SMTP (opcional)',
    dkimDomain: 'Dominio DKIM local (opcional)',
    dkimSelector: 'Selector DKIM local (opcional)',
    dkimPrivateKey: 'Clave privada DKIM local (opcional)',
    makeDefault: 'Usar como proveedor de marketing predeterminado',
    provider: 'Proveedor de marketing',
    domain: 'Subdominio de marketing dedicado',
    sender: 'Dirección remitente',
    returnPath: 'Dirección Return-Path',
    selector: 'Selector DKIM',
    evidence: 'Configuración y responsabilidad documentadas',
    coverage: 'Confirmo que DKIM firma todas las cabeceras obligatorias de marketing y baja.',
    softBounceThreshold: 'Límite de rebotes temporales',
    validityHours: 'Validez de comprobación en horas',
    bounceAlert: 'Alerta de rebote en porcentaje',
    complaintAlert: 'Alerta de quejas en porcentaje',
    riskAcknowledgement: 'Confirmo la revisión operativa de estos umbrales.',
  },
  types: { SHARED_SMTP: 'Transporte SMTP compartido existente', SMTP: 'Transporte SMTP dedicado' },
  actions: {
    createProvider: 'Guardar proveedor',
    createDomain: 'Añadir dominio',
    check: 'Comprobar DNS ahora',
    rotateToken: 'Renovar token',
    rotateWebhook: 'Renovar secreto webhook',
    saveSettings: 'Guardar umbrales',
  },
  status: { PENDING: 'Pendiente', VERIFIED: 'Verificado', FAILED: 'Fallido' },
  check: { PENDING: 'Pendiente', PASS: 'Correcto', FAIL: 'Fallido' },
  checks: {
    ownership: 'Propiedad del dominio',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return-Path',
    sender: 'Remitente y flujo separado',
  },
  recordsTitle: 'Registros DNS obligatorios',
  ownershipRecord: 'TXT de verificación de dominio',
  spfRecord: 'TXT SPF en Return-Path',
  dkimRecord: 'TXT con clave DKIM pública',
  dmarcRecord: 'TXT DMARC',
  requiredHeaders: 'Cabeceras DKIM obligatorias',
  lastChecked: 'Última comprobación',
  neverChecked: 'Aún sin comprobar',
  oneTimeTitle: 'Datos de configuración mostrados una sola vez',
  tokenWarning:
    'Copie ahora este valor al DNS. El texto claro no se guarda y luego solo puede sustituirse.',
  webhookTitle: 'Webhook de proveedor firmado',
  webhookDescription:
    'El proveedor envía eventos HTTPS POST con marca temporal y firma HMAC-SHA-256. Los identificadores deben ser únicos.',
  webhookWarning: 'Copie ahora la URL y el secreto; el secreto no se volverá a mostrar.',
  webhookUrl: 'URL del webhook',
  webhookSecret: 'Secreto del webhook',
  signatureHeader: 'Cabecera de firma',
  timestampHeader: 'Cabecera de tiempo',
  settingsTitle: 'Umbrales de rebote y alerta',
  messages: {
    providerCreated: 'El proveedor de marketing se guardó cifrado.',
    domainCreated: 'Se añadió el dominio. Publique ahora los registros DNS.',
    domainChecked: 'La comprobación DNS se registró de forma inmutable.',
    tokenRotated: 'Se revocó el token anterior.',
    webhookRotated: 'Se renovó el secreto webhook.',
    settingsSaved: 'Se guardaron los umbrales.',
    failed: 'No se pudo guardar o comprobar la configuración.',
  },
} as const;

export const newsletterDeliverabilityRu = {
  ...newsletterDeliverabilityEn,
  tab: 'Доставляемость',
  title: 'Домены отправки и доставляемость',
  description:
    'Маркетинговая рассылка разрешается только после актуальной проверки SPF, DKIM, DMARC, Return-Path, отправителя и домена. Транзакционная почта идёт отдельно.',
  measurementNotice:
    'Доставка — это сигнал провайдера, а не гарантия попадания во входящие. Показатели за 30 дней.',
  providersTitle: 'Провайдеры маркетинговой рассылки',
  providersDescription:
    'Учётные данные хранятся в зашифрованном виде. Секреты повторно не загружаются.',
  domainTitle: 'Маркетинговый домен отправки',
  domainDescription: 'Используйте отдельный поддомен, опубликуйте DNS-записи и запустите проверку.',
  noDomains: 'Домен маркетинговой отправки не настроен.',
  noProviders: 'Маркетинговый провайдер не настроен.',
  metrics: {
    accepted: 'Принято провайдером',
    delivered: 'Отмечено провайдером как доставленное',
    softBounces: 'Временные ошибки',
    hardBounces: 'Постоянные ошибки',
    complaints: 'Жалобы на спам',
    deliveredRate: 'Заявленная доставка',
    bounceRate: 'Доля возвратов',
    complaintRate: 'Доля жалоб',
  },
  alertTitle: 'Предупреждение о доставляемости',
  alerts: {
    BOUNCE_RATE_HIGH: 'Доля возвратов выше заданного порога.',
    COMPLAINT_RATE_HIGH: 'Доля жалоб выше заданного порога.',
  },
  fields: {
    ...newsletterDeliverabilityEn.fields,
    providerName: 'Имя провайдера',
    providerType: 'Транспорт',
    fromAddress: 'Адрес маркетингового отправителя',
    host: 'Сервер SMTP',
    port: 'Порт SMTP',
    secure: 'Подключаться к SMTP через TLS',
    username: 'Имя пользователя SMTP (необязательно)',
    password: 'Пароль SMTP (необязательно)',
    dkimDomain: 'Локальный домен DKIM (необязательно)',
    dkimSelector: 'Локальный селектор DKIM (необязательно)',
    dkimPrivateKey: 'Локальный закрытый ключ DKIM (необязательно)',
    makeDefault: 'Использовать как маркетинговый провайдер по умолчанию',
    provider: 'Маркетинговый провайдер',
    domain: 'Отдельный маркетинговый поддомен',
    sender: 'Адрес отправителя',
    returnPath: 'Адрес Return-Path',
    selector: 'Селектор DKIM',
    evidence: 'Описание конфигурации и ответственности',
    coverage: 'Подтверждаю, что DKIM подписывает все обязательные заголовки.',
    softBounceThreshold: 'Порог временных возвратов',
    validityHours: 'Срок проверки домена в часах',
    bounceAlert: 'Порог возвратов, %',
    complaintAlert: 'Порог жалоб, %',
    riskAcknowledgement: 'Подтверждаю операционную проверку этих порогов.',
  },
  types: { SHARED_SMTP: 'Существующий общий SMTP-транспорт', SMTP: 'Отдельный SMTP-транспорт' },
  actions: {
    createProvider: 'Сохранить провайдера',
    createDomain: 'Добавить домен',
    check: 'Проверить DNS',
    rotateToken: 'Обновить токен',
    rotateWebhook: 'Обновить секрет webhook',
    saveSettings: 'Сохранить пороги',
  },
  status: { PENDING: 'Ожидает', VERIFIED: 'Подтверждён', FAILED: 'Ошибка' },
  check: { PENDING: 'Ожидает', PASS: 'Успешно', FAIL: 'Ошибка' },
  checks: {
    ownership: 'Владение доменом',
    spf: 'SPF',
    dkim: 'DKIM',
    dmarc: 'DMARC',
    returnPath: 'Return-Path',
    sender: 'Отправитель и отдельный поток',
  },
  recordsTitle: 'Обязательные DNS-записи',
  ownershipRecord: 'TXT проверки домена',
  spfRecord: 'TXT SPF для Return-Path',
  dkimRecord: 'TXT с открытым ключом DKIM',
  dmarcRecord: 'TXT DMARC',
  requiredHeaders: 'Обязательные DKIM-заголовки',
  lastChecked: 'Последняя проверка',
  neverChecked: 'Ещё не проверено',
  oneTimeTitle: 'Одноразово показанные данные',
  tokenWarning: 'Скопируйте значение в DNS. Открытый текст не хранится.',
  webhookTitle: 'Подписанный webhook провайдера',
  webhookDescription:
    'Провайдер отправляет HTTPS POST с меткой времени и HMAC-SHA-256. ID событий должны быть уникальны.',
  webhookWarning: 'Скопируйте URL и секрет сейчас; секрет больше не покажется.',
  webhookUrl: 'URL webhook',
  webhookSecret: 'Секрет webhook',
  signatureHeader: 'Заголовок подписи',
  timestampHeader: 'Заголовок времени',
  settingsTitle: 'Пороги возвратов и оповещений',
  messages: {
    providerCreated: 'Маркетинговый провайдер сохранён в зашифрованном виде.',
    domainCreated: 'Домен добавлен. Опубликуйте DNS-записи.',
    domainChecked: 'Проверка DNS неизменяемо записана.',
    tokenRotated: 'Старый токен отозван.',
    webhookRotated: 'Секрет webhook обновлён.',
    settingsSaved: 'Пороги сохранены.',
    failed: 'Не удалось сохранить или проверить конфигурацию.',
  },
} as const;
